module.exports = __webpack_public_path__ + "static/media/banner.ac5c1429.jpeg";